import { render, staticRenderFns } from "./dropdown.vue?vue&type=template&id=8b70bac4&scoped=true&"
var script = {}
import style0 from "./dropdown.vue?vue&type=style&index=0&id=8b70bac4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b70bac4",
  null
  
)

export default component.exports